// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Slide_wrap__pVcXy","customSlickDots":"Slide_customSlickDots__3ohjo"};